import { render, staticRenderFns } from "./JoinButton.vue?vue&type=template&id=21ae6a21&scoped=true&"
import script from "./JoinButton.vue?vue&type=script&lang=ts&"
export * from "./JoinButton.vue?vue&type=script&lang=ts&"
import style0 from "./JoinButton.vue?vue&type=style&index=0&id=21ae6a21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ae6a21",
  null
  
)

component.options.__file = "JoinButton.vue"
export default component.exports